<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Lesson Plan Detail Report</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a
            href="javascript:;"
            class="btn btn-sm btn-dark btn-with-addon"
            @click="handleBackButton"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-chevron-left" />
            </span>
            Back
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <p class="text-muted">
              View lesson plan Detail Report
            </p>
            <!-- The child component does all the heavy lifting -->
            <display-lesson-plan />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplayLessonPlan from '@/components/lessonplan/report/detailReport/index'

export default {
  name: 'LessonPlanDetailReport',
  components: {
    DisplayLessonPlan,
  },
  methods: {
    handleBackButton() {
      this.$router.push({ name: 'lessonplan-overview-report' })
    },
  },
}
</script>
